const path = {
  root: '/',
  login: '/login',
  loginForCloudsignReview: '/login_for_cloudsign_review',
  loginForLeFILING: '/login_for_lefiling',
  passwordReset: '/password_reset/',
  contractList: '/contract_list',
  splitUserTemplate: '/split_user_template',
  editUserTemplate: '/v2/user_template_editor',
  cabinetMaster: '/cabinet_master',
  contractDiff: '/contract_diff',
  companyContractTagList: '/company_contract_tag_list',
  clientList: '/client_list',
  reviewContract: '/review_contract',
  searchJoubun: '/v2/search_joubun',
  terms: '/terms',
  termsNoAuto: '/terms_no_auto',
  chatGptTerms: '/chatgpt_terms',
  serviceLaw: '/service_law',
  helpCenter: '/help_center',
  prioritySettings: '/priority_settings',
  userSettings: '/v2/user_settings',
  pageNotFound: '/*'
};

module.exports = path;



// WEBPACK FOOTER //
// ./src/constants/path.js